import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppSharedModule } from 'app/app-shared.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { UiSwitchModule } from 'ngx-ui-switch';
import { ConfirmacaoModalModule } from '../confirmacao-modal/confirmacao-modal..module';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DownloadFilePageComponent } from './download-file-page/download-file-page.component';
import { FormUploadFileComponent } from './download-file-page/form-upload-file/form-upload-file.component';
import { FormEditProductComponent } from './download-file-page/form-edit-product/form-edit-product.component';
import { CategoryManagementComponent } from './download-file-page/category-management/category-management.component';
import { FileCategoryManagementComponent } from './download-file-page/file-category-management/file-category-management.component';
@NgModule({
  declarations: [
    DownloadFilePageComponent,
    FormUploadFileComponent,
    FormEditProductComponent,
    CategoryManagementComponent,
    FileCategoryManagementComponent,
  ],
  imports: [
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,

    CommonModule,
    TranslateModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    BrowserModule,
    TooltipModule.forRoot(),
    ConfirmacaoModalModule,
    UiSwitchModule,
    BrowserAnimationsModule,
    AppSharedModule,
  ],
  exports: [],
})
export class AreaTrabalhoModule {}
